import { Container } from "@mui/material";
import Hero from "../components/hero/Hero";
import BookkeepingGrid from "../components/cards/Cards";
import Faq from "../components/faq/Faq";
import Carousel from "../components/carousel/Carousel";
import SuccessStory from "../components/successStoryBanner/SuccessStory";
import Achievements from "../components/achievements/Achievements"

const desc = (
  <>
    <p>
      We are more than just tax and bookkeeping professionals — we are your{" "}
      <strong>trusted partner in business growth</strong>. We provide{" "}
      <strong>expert services in taxation, compliance, precision bookkeeping</strong>, 
      business registration, and strategic business advisory, helping you simplify 
      your finances and focus on what matters most: growing your business.
    </p>
    <p>
      We recognise that every business is unique. That’s why <strong>our services are tailored</strong> to meet the 
      specific needs of each client, whether you are starting a new venture, managing daily operations, 
      or navigating complex tax regulations. Our experienced team adopts a proactive, hands-on approach 
      to ensure your financial records are accurate, compliant, and aligned with your business goals.
    </p>
    <p>
      <strong>From start-ups to established companies</strong>, we support businesses at every stage to 
      operate efficiently, optimise financial processes, and make informed decisions. Our mission is to 
      provide clarity, confidence, and peace of mind, so you can spend less time worrying about numbers and 
      more time driving your business forward.
    </p>
  </>
);

function HomePage() {
  return (
    <>
      <Hero 
        contentAlign='center'
        title="Aspire Tax and Bookkeeping"
        titleAlign='center'
        subTitleAlign='center'
        backgroundImage={'url(/assets/meeting.webp)'}
        
        primaryButton={{
        text: 'Book Now',
        className: 'hero-box__button',
        route:'/book-now',
        }}
        
        secondayButton={{
        text: 'Explore Services',
        className: 'hero-box__transparentButton',
        route:'/services#services-section',
        }}
      />
      
      <Achievements
      title="Tailored Taxation Services in Australia" 
      titleColor="#0A0A7B" 
      secondTitle="Trusted Nationwide" 
      secondTitleColor="#23A215"
      description={desc}
      truncateWords={100}
      sideImage={'/assets/Image-Container.png'}
      button={{
      text: 'Contact Us',
      className: 'achievements-stack-button',
      route:'/contact-us',
      }}
      />

      <SuccessStory/>
      <BookkeepingGrid />
      <Carousel />
      <Container maxWidth="xl">
        <Faq />
      </Container>
    </>
  );
}

export default HomePage;
